/**
 * Website Lead Integration webhook URL helpers.
 *
 * GET /webhook/config used to return `?secret=***` as a mask. Copying that
 * URL into WordPress authenticates as the literal string "***" and every
 * submission 401s. Never present a masked URL as copyable.
 */

export const MASKED_WEBHOOK_SECRET = '***';

export function webhookUrlHasMaskedSecret(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.searchParams.get('secret') === MASKED_WEBHOOK_SECRET;
  } catch {
    return /[?&]secret=\*\*\*(?:&|$)/.test(url);
  }
}

/**
 * URL the owner can paste into WordPress.
 * `newSecret` is the full secret from create/regenerate (shown once).
 * Returns null when the stored URL is still masked and no fresh secret is available.
 */
export function resolveCopyableWebhookUrl(
  webhookUrl: string | undefined | null,
  newSecret?: string | null,
): string | null {
  if (!webhookUrl) return null;

  if (newSecret) {
    try {
      const parsed = new URL(webhookUrl);
      parsed.searchParams.set('secret', newSecret);
      return parsed.toString();
    } catch {
      return webhookUrl.replace(
        /([?&]secret=)[^&]*/,
        `$1${newSecret}`,
      );
    }
  }

  if (webhookUrlHasMaskedSecret(webhookUrl)) return null;
  return webhookUrl;
}
